import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-4">
      <ol className="flex items-center flex-wrap gap-1.5 text-sm text-foreground-500">
        <li>
          <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">
            <i className="ri-home-4-line"></i>
            <span className="sr-only">首页</span>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-500 transition-colors cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}